import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const CopyStyle = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M11.9016 6.3735C12.3437 7.33289 11.9267 8.46837 10.975 8.91144C9.76633 9.47412 8.19647 9.40616 6.63487 7.84602C6.64459 7.83567 6.65753 7.82444 6.67397 7.81397C6.70313 7.79541 6.73586 7.78399 6.76819 7.78102C7.19544 7.74175 7.51765 7.58947 7.76776 7.34188C7.98304 7.12877 8.12397 6.8607 8.23383 6.65173C8.23892 6.64205 8.24394 6.6325 8.2489 6.62309C8.47854 6.18716 8.70288 5.76647 9.38224 5.43981C10.4334 4.93442 11.4483 5.38964 11.9016 6.3735Z"
        stroke={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8617 5.5351L13.8109 2.75515C13.9518 2.55413 13.904 2.27653 13.7039 2.13512C13.5039 1.9937 13.2275 2.04202 13.0866 2.24305L11.1428 5.01541C10.8114 4.86353 10.4428 4.79408 10.0566 4.82468L10.2862 4.49717L12.271 1.6664C12.7294 1.01265 13.6282 0.855504 14.2787 1.31539C14.9291 1.77529 15.0849 2.67806 14.6265 3.33181L12.6417 6.16258L12.4284 6.46687C12.4029 6.39389 12.3737 6.32147 12.3407 6.24984C12.2158 5.9788 12.0534 5.73815 11.8617 5.5351Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.95007 2.78673C10.182 2.45534 9.94497 2 9.54045 2H5.4375C4.60907 2 3.9375 2.67157 3.9375 3.5V10.625C3.9375 11.4534 4.60907 12.125 5.4375 12.125H11.5938C12.4222 12.125 13.0938 11.4534 13.0938 10.625V10.5617C13.0938 10.2855 12.8699 10.0617 12.5938 10.0617C12.3176 10.0617 12.0938 10.2855 12.0938 10.5617V10.625C12.0938 10.9011 11.8699 11.125 11.5938 11.125H5.4375C5.16136 11.125 4.9375 10.9011 4.9375 10.625V3.5C4.9375 3.22386 5.16136 3 5.4375 3H9.54045C9.70361 3 9.85651 2.92039 9.95007 2.78673ZM1.00503 13.0781C1.00503 14.1827 1.90046 15.0781 3.00503 15.0781H8.72705C9.44143 15.0781 10.0205 14.499 10.0205 13.7846C10.0205 13.5085 9.79669 13.2846 9.52055 13.2846C9.24441 13.2846 9.02055 13.5085 9.02055 13.7846C9.02055 13.9467 8.88914 14.0781 8.72705 14.0781H3.00503C2.45274 14.0781 2.00503 13.6304 2.00503 13.0781V5.52193C2.00503 5.389 2.11278 5.28125 2.2457 5.28125C2.52185 5.28125 2.7457 5.05739 2.7457 4.78125C2.7457 4.50511 2.52185 4.28125 2.2457 4.28125C1.5605 4.28125 1.00503 4.83672 1.00503 5.52193V13.0781Z"
        fill={color}
      />
    </svg>
  )
})

export default CopyStyle
